import React from "react";

const AboutSection = ({ visimisi, gambarVisi, kesankesan, gambarKesan }) => {

  return (
    <section
      id="about-us"
      className="py-10 bg-gray-900 bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('https://osis.sman2amlapura.sch.id/img/map-image.png')",
      }}
    >
      <div className="container px-5 mx-auto">
        <div className="mb-10 text-center">
          <h2 className="text-3xl font-bold text-white uppercase">About Us</h2>
        </div>

        {/* Visi Misi Section */}
        <div className="grid grid-cols-1 gap-8 items-center md:grid-cols-3">
          <div className="md:col-span-2">
            <div
              className="text-lg text-gray-300"
              dangerouslySetInnerHTML={{ __html: visimisi }}
            />
          </div>
          <div className="flex justify-center">
            <img
              src={`https://admin.sman2amlapura.sch.id/images/artikel/${gambarVisi}`}
              alt="Visi Misi"
              className="w-full max-w-sm rounded-lg shadow-lg"
            />
          </div>
        </div>

        {/* Kesan-kesan Section */}
        {/* <div className="grid grid-cols-1 gap-8 items-center mt-12 md:grid-cols-3">
          <div className="flex justify-center">
            <img
              src={`https://admin.sman2amlapura.sch.id/images/artikel/${gambarKesan}`}
              alt="Kesan"
              className="w-full max-w-2xl rounded-lg shadow-lg"
            />
          </div>
          <div className="md:col-span-2">
            <div
              className="text-lg text-gray-300"
              dangerouslySetInnerHTML={{ __html: kesankesan }}
            />
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default AboutSection;
